/* tslint:disable */
export enum ActionPageEnumDto {
  Add = 'Add',
  Delete = 'Delete',
  Update = 'Update',
  Continue = 'Continue',
  Approval = 'Approval'
}
